export const getPendingReducer = state => {
  state.isLoading = true;
};

export const getRejectedReducer = state => {
  state.isLoading = false;
};

export const getClientAnonymityInfoFulfilledReducer = (state, action) => {
  state.isLoading = false;
  state.anonymityInfo = action.payload;
};
